import * as roomsActions from '@store/rooms/actions';
import { yourJourneySelectors } from '@store/yourJourney';
import { entitySelectors } from '@store/entity/selectors';
import { connect } from 'react-redux';
import { DatesPicker } from './DatesPicker';
import { roomsSelectors } from '@store/rooms';

const mapStateToProps = (state) => ({
  propertyId: entitySelectors.getProperty(state).id,
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  availability: roomsSelectors.getRoomRateAvailability(state),
});

export const mapDispatchToProps = (dispatch) => ({
  fetchAvailability: roomsActions.fetchRoomRateAvailability(dispatch),
});

export const DatesPickerConnected: any = connect(mapStateToProps, mapDispatchToProps)(DatesPicker);
